import Vue from 'vue';
import utils from '@/services/utils';
import { isObject } from 'lodash';

// TODO: move to common modules as its shared between repo
Vue.filter('currency', function (num) {
  if (isObject(num)) {
    num = num.value;
  }

  if (isNaN(num)) return '-';
  return new Intl.NumberFormat(`${utils.getCurrentLanguage()}-${SMP_CONFIG.countryConfig.countryCode}`,
    { style: 'currency', currency: SMP_CONFIG.countryConfig.currency.code }).format(num);
});
